import React from "react";
import { Spin } from "antd";

export const Loading = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <Spin size="large" className="mb-4" />
        <p className="text-gray-600 text-lg font-medium">Yükleniyor...</p>
      </div>
    </div>
  );
};
